import React from 'react';
import { loanOfficers } from '../data/commissionData';
interface OfficerSelectProps {
  value: string;
  onChange: (officerId: string) => void;
  label?: string;
}
export function OfficerSelect({
  value,
  onChange,
  label = 'Loan officer'
}: OfficerSelectProps) {
  return <div data-id="element-101" data-mp="wcjxvsb33bo6">
      <label htmlFor="officer-select" className="block text-xs font-semibold uppercase tracking-wide text-slate-500" data-id="element-102" data-mp="wctq7mjlpux1">
        {label}
      </label>
      <select id="officer-select" value={value} onChange={event => onChange(event.target.value)} className="mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-900 shadow-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-200" data-id="element-103" data-mp="1aa8hkwtf0crn">
        {loanOfficers.map(officer => <option key={officer.id} value={officer.id} data-id="element-104" data-mp="1u0u4kkltenlm">
            {officer.name} — {officer.branch}
          </option>)}
      </select>
    </div>;
}